<div [class.loader-hidden]="!show" class="loader-background">
    <div class="loader-overlay">
       <img [src]="image" width="100" height="100">
    </div>
</div>